import { api } from './api.js';
import { Frame } from './components.js';
import { CoalitionPage, FunderPage, HomePage, NotFoundPage, OrganizationPage, SubjectPage } from './pages.js';
import { useRoute } from './router.js';

const Page = () => {
  const route = useRoute();
  switch (route.kind) {
    case 'home':
      return <HomePage />;
    case 'organization':
      return <OrganizationPage ein={route.ein} />;
    case 'funder':
      return <FunderPage ein={route.ein} />;
    case 'subject':
      return <SubjectPage slug={route.slug} />;
    case 'coalition':
      return <CoalitionPage label={route.ein} lookup={() => api.coalitionMap(route.ein)} />;
    case 'coalition-cluster':
      return <CoalitionPage label={`${route.window}/${route.hash}`} lookup={() => api.coalitionMapByCluster(route.window, route.hash)} />;
    case 'not-found':
      return <NotFoundPage path={route.path} />;
  }
};

export const App = () => (
  <Frame>
    <Page />
  </Frame>
);
